export default function useJustHireUrl(path: string): string {
  return `${useRuntimeConfig().public.justHireUrl}${path}`;
}
